module.exports = __webpack_public_path__ + "img/FSA Web Banner.ab66f4de.png";